/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { AzureFieldRow } from "../row/AzureFieldRow";
import { BaseUUID, BaseMetaColumn, FilterItem, SortItem } from "namirasoft-core";
import { NSBaseMetaDatabase, NSBaseMetaTable } from "namirasoft-site";
import { NamirasoftBillWatchServer } from "../NamirasoftBillWatchServer";

export class AzureFieldMetaTable extends NSBaseMetaTable<NamirasoftBillWatchServer, AzureFieldRow>
{
    public override columns: {
        id: BaseMetaColumn;
        user_id: BaseMetaColumn;
        entity_id: BaseMetaColumn;
        field_id: BaseMetaColumn;
        value: BaseMetaColumn;
        created_at: BaseMetaColumn;
        updated_at: BaseMetaColumn;
    }
    constructor(database: NSBaseMetaDatabase<NamirasoftBillWatchServer>)
    {
        super(database, "azure_field", "Azure Field", new BaseUUID(""));
        this.columns = {
            id: new BaseMetaColumn(this, "id", "ID", "Integer", true),
            user_id: new BaseMetaColumn(this, "user_id", "User ID", "String", true),
            entity_id: new BaseMetaColumn(this, "entity_id", "Entity ID", "String", true),
            field_id: new BaseMetaColumn(this, "field_id", "Field ID", "String", true),
            value: new BaseMetaColumn(this, "value", "Value", "Any", false),
            created_at: new BaseMetaColumn(this, "created_at", "Created At", "DateTime", true),
            updated_at: new BaseMetaColumn(this, "updated_at", "Updated At", "DateTime", true),
        };
        this.back_end.get = async (id: string) =>
        {
            let server = this.database.getServer();
            return await server.azure_field.Get(id);
        };
        this.back_end.list = async (filters: FilterItem[] | null, page: (number | null), size: (number | null), sorts: SortItem[]) =>
        {
            let server = this.database.getServer();
            return await server.azure_field.List(filters, page, size, sorts);
        };
    }
};